import { useLanguage } from '@/i18n/LanguageContext';
import { formatNumber } from '@/i18n/format';
import type { StockSummary } from '@/api/types';
import type { TranslationKey } from '@/i18n/dictionaries/en';

/**
 * Stock projection buckets (apps/api/src/stockBuckets.ts). "Available" is the
 * sellable/pickable figure; "Shipped" is a ledger position for goods that
 * already left custody and is deliberately shown apart from physical stock.
 */
export function StockSummaryStrip({ summary }: { summary: StockSummary }): JSX.Element {
  const { t, locale } = useLanguage();
  const cells: readonly (readonly [TranslationKey, string])[] = [
    ['inventory.summary.inBins', summary.qty_in_bins],
    ['inventory.summary.available', summary.qty_available],
    ['inventory.summary.quarantine', summary.qty_quarantine],
    ['inventory.summary.inProcess', summary.qty_in_process],
    ['inventory.summary.shipped', summary.qty_shipped],
  ];
  return (
    <div className="grid-cards" role="group" aria-label={t('inventory.summary.title')}>
      {cells.map(([key, value]) => (
        <div key={key} className="stat-card">
          <div className="n">{formatNumber(value, locale)}</div>
          <div className="label">{t(key)}</div>
        </div>
      ))}
    </div>
  );
}
